import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertsService } from '@tablesready/frontend-alerts-bar';

enum navTabs {
  profileDetails = 'Profile details',
  accountsAccess = 'Accounts access',
}

@Component({
  selector: 'tablesready-profile',
  templateUrl: './profile.component.html',
})
export class ProfileComponent implements OnInit {
  navigationTabs = navTabs;
  tabs = [navTabs.profileDetails, navTabs.accountsAccess];
  activeTab: string = this.tabs[0];

  constructor(
    private readonly alertsService: AlertsService,
    private readonly activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    const { queryParamMap } = this.activatedRoute.snapshot;
    const navigateToAccountsAccessTab = queryParamMap.get('accountsAccessTab');

    if (navigateToAccountsAccessTab) {
      this.activeTab = navTabs.accountsAccess;
    }
  }

  onChangeNav(changeTo: string): void {
    this.activeTab = changeTo;
  }
}
